<template>
    <el-dialog :title="title" :visible.sync="dialogTableVisible" @close="closeDialog" width="80%">
        <el-table :data="list" v-loading="loading">
            <el-table-column prop="id" label="订单ID"></el-table-column>
            <el-table-column prop="customer_name" label="客户名称"></el-table-column>
            <el-table-column prop="user_name" label="成交产品">
                <template slot-scope="scope">
                    <div v-if="scope.row.products.length == 1">
                        <span v-if="!scope.row.products[0].is_new">
                            <el-button size="mini" type="primary" v-if="scope.row.products[0].is_active">
                                {{ scope.row.products[0].product_name }}
                            </el-button>
                            <el-button size="mini" type="info" v-else>{{ scope.row.products[0].product_name }}
                            </el-button>
                        </span>
                    </div>
                    <div v-else-if="scope.row.products.length > 1">
                        <el-tooltip class="item" effect="dark" placement="bottom">
                            <div slot="content" v-for="value in scope.row.products" :key="value.id" v-show="!value.is_new">
                                <el-button size="mini" type="primary" v-if="value.is_active">{{ value.product_name
                                    }}
                                </el-button>
                                <el-button size="mini" type="info" v-else>
                                    {{ value.product_name }}
                                </el-button>
                            </div>
                            <span v-if="!scope.row.products[0].is_new">
                                <el-button size="mini" type="primary" v-if="scope.row.products[0].is_active">
                                    {{ scope.row.products[0].product_name }}
                                </el-button>
                                <el-button size="mini" type="info" v-else>
                                    {{ scope.row.products[0].product_name }}
                                </el-button>
                            </span>
                            <span v-else>
                                <el-button size="mini" type="primary" v-if="scope.row.products[1].is_active">
                                    {{ scope.row.products[1].product_name }}
                                </el-button>
                                <el-button size="mini" type="info" v-else>
                                    {{ scope.row.products[1].product_name }}
                                </el-button>
                            </span>
                        </el-tooltip>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="地区">
                <template slot-scope="scope">
                    {{scope.row.customers && scope.row.customers.district_names ? scope.row.customers.district_names : ''}}
                </template>
            </el-table-column>
            <el-table-column prop="user_name" label="订单负责人">
                <template slot-scope="scope">
                    <div v-for="(user, index) in scope.row.user" :key="index" v-show="user.is_cooperator == 0">
                        {{user.name}}
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="branch_name" label="所属部门">
                <template slot-scope="scope">
                    <div v-for="(user, index) in scope.row.user" :key="index" v-show="user.is_cooperator == 0">
                        {{user.branch_name}}
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="created_at" label="录单时间"></el-table-column>
            <el-table-column label="操作"  fixed="right">
                <template slot-scope="scope">
                    <el-button @click="handleView(scope.row)" type="text"  size="small">查看</el-button>
                </template>
            </el-table-column>
        </el-table>
        <MyPagination :linkPage="linkPage" @size-change="handleSizeChange" @current-change="handleCurrentChange"></MyPagination>
    </el-dialog>
</template>
<script>
    import SaleanalysisCount from "~/services/saleanalysisCount";
    import MyPagination from "~/widgets/MyPagination.vue";
    export default {
        props:{
            params:{
                type: Object,
                required: true,
            },
            title:{
                type: String,
                required: false,
                default: '订单列表'
            },
        },
        components: {
            MyPagination
        },
        data(){
            return {
                list:[],
                loading: false,
                dialogTableVisible: true,
                linkPage: null,
            }
        },
        created() {
            this.getList();
        },
        methods: {
            //获取列表
            getList() {
                // loading 动画
                this.loading = true;
                SaleanalysisCount.getList(this.params, 'day-order-list')
                .then((res) => {
                    if (res.code == 0) {
                        this.list = res.data;
                    }
                    if (res._meta) {
                        this.linkPage = res._meta;
                    }
                    this.loading = false;
                })
                .catch((err) => {
                    console.error(err);
                    this.loading = false;
                });
            },

            handleView(row) {
                let routeData = this.$router.resolve({
                    path: "/order/view",
                    query: { id: row.id },
                });
                window.open(routeData.href, '_blank');
            },

            handleSizeChange(newSize) {
                // 处理每页条目数变化事件
                let params = this.params;
                params['perPage'] = newSize;
                this.getList(params);
            },

            handleCurrentChange(newPage) {
                let params = this.params;
                // 处理当前页码变化事件
                params['page'] = newPage;
                this.getList(params);
            },
            
            closeDialog(){
                this.dialogTableVisible = false;
                this.$emit("close", []);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/count/dialog/DayOrderDialog.vue